"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToasts = exports.initializeToasts = exports.ToastContextProvider = exports.ToastContext = void 0;
// tslint:disable:react-hooks-nesting
const React = __importStar(require("react"));
exports.ToastContext = React.createContext((toast) => { return; });
exports.ToastContext.displayName = 'ToastContext';
exports.ToastContextProvider = exports.ToastContext.Provider;
const initializeToasts = () => {
    const [toasts, setToasts] = React.useState([]);
    const addNewToast = React.useCallback((toast) => {
        setToasts((oldToasts) => [
            Object.assign({ id: createId() }, toast),
            ...oldToasts,
        ]);
    }, []);
    const removeToast = React.useCallback((id) => {
        setToasts((oldToasts) => [
            ...oldToasts.filter((toast) => toast.id !== id),
        ]);
    }, []);
    return { toasts, addNewToast, removeToast };
};
exports.initializeToasts = initializeToasts;
const createId = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
const useToasts = () => {
    const context = React.useContext(exports.ToastContext);
    if (!context) {
        throw Error('The `useToast` hook must be called from a descendent of the `ToastContextProvider`. ' +
            'Did you forget to create one?');
    }
    return {
        addToast: context,
    };
};
exports.useToasts = useToasts;
//# sourceMappingURL=toasts.js.map